import ContractStructureMdl from '@/models/HumanResource/HrContractStructure'

export default async () => {
    try {
        let response = await ContractStructureMdl.params({
            get_all_results: true,
        }).get()
        return response.data
    } catch (error) {
        return error.response.data
    }
}
